// src/pages/CallbackPage.jsx
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { verifyCodeAPI } from "../features/auth/authAPI";
import { loginSuccess, loginFailure } from "../features/auth/authSlice";
import "../styles/loader.css";
import { authService } from "../services/authService";

function CallbackPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const verifyCode = async () => {
      const code = searchParams.get("code");
      const codeChallenge = searchParams.get("state");
      if (!code || !codeChallenge) {
        alert("로그인에 실패했습니다. 다시 시도해주세요.");
        navigate("/login");
        return;
      }

      const data = {
        code: code,
        code_challenge: codeChallenge,
      };

      try {
        const response = await verifyCodeAPI(data);

        const accessToken = response.data["access_token"];
        const refreshToken = response.data["refresh_token"];
        authService.setTokens(accessToken, refreshToken);

        if (response.status === 200) {
          dispatch(loginSuccess());
          navigate("/home");
        } else {
          dispatch(loginFailure());
          alert("로그인에 실패했습니다. 다시 시도해주세요.");
          navigate("/login");
        }
      } catch (error) {
        dispatch(loginFailure());
        alert("로그인에 실패했습니다. 다시 시도해주세요.");
        navigate("/login");
      }
    };

    verifyCode();
  }, [dispatch, navigate, searchParams]);

  return (
    <div className="loader-container">
      <div className="loader"></div>
    </div>
  );
}

export default CallbackPage;
